import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import CustomInput from "../../../Component/BasicComponents/CustomInput";

import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { FaEdit } from "react-icons/fa";
import {
  useAddGeoDistace,
  useGetConfigStatus,
  useGetGeoDistanceList,
  useGetTownList,
  useUpdateGeoDistannce,
} from "./hook/GeoDistanceRepo";
import { useGetStateList } from "../../Configuration/HolidayConfiguration/hooks/useHoliday";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getTownList, getTownList2 } from "./hook/useGeoDistance";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import CustomDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { showToast } from "../../../utils/toastUtils";
import axiosInstance from "../../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import { useExcelPolling } from "../../../hooks/useExcelPolling";
import { Spinner } from "reactstrap";
import { COLORS } from "../../../constants/colors";

interface formInterface {
  GeoDistanceId: number | null;
  BeltName: string | undefined;
  FromStateId: number | null;
  FromTownId: number | null;
  FromTownName: string | null;
  ToStateId: number | null;
  ToTownId: number | null;
  ToTownName: string | null;
  CalculationType: string;
  DistanceKm: number | null;
  Amount: number | null;
  Remark: string;
  TravelDocNeeded: string;
}

interface RebBodyInterface {
  BeltName?: string | undefined;
  FromStateId: number | null;
  FromTownId: number | null;
  ToStateId: number | null;
  ToTownId: number | null;
  CalculationType: string;
  DistanceKm: number | null;
  Amount: number | null;
  Remark: string;
  TravelDocNeeded: string;
}

const ExpGeoDistance = () => {
  const { startPolling, stopPolling } = useExcelPolling();
  const [modalVisiable, setModalVisiable] = React.useState(false);
  const [selectedGeoDistanceStatus, setSelectedGeoDistanceStatus] =
    React.useState("All");
  const [status, setStatus] = useState("");
  const [setMoreTownData, setSetMoreTownData] = useState(true);
  const [RowData, setRowData] = useState<formInterface | null>(null);

  const [TownOption, setTownOption] = useState<any[]>([]);
  const [From_Towm_HasMore, setFrom_Towm_HasMore] = useState(true);
  const [FromTownPage, setFromTownPage] = useState(1);
  const [TownSeach, setTownSeach] = useState("");

  // To Towm
  const [To_Town_search, setTo_Town_search] = useState("");
  const [To_Town_Option, setTo_Town_Option] = useState<any[]>([]);
  const [From_To_Towm_HasMore, setFrom_To_Towm_HasMore] = useState(true);
  const [From_To_TownPage, setFrom_To_TownPage] = useState(1);
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  useEffect(() => {
    if (status === "Edit") {
      setSelectedTown({
        id: Number(RowData?.FromTownId),
        label: String(RowData?.FromTownName),
      });
      setSelectedTo_Town({
        id: Number(RowData?.ToTownId),
        label: String(RowData?.ToTownName),
      });
    }
  }, [status]);

  useEffect(() => {
    setTownOption([]);
    setFromTownPage(1);
    setFrom_Towm_HasMore(true);
  }, [TownSeach]);

  useEffect(() => {
    setTo_Town_Option([]);
    setFrom_To_TownPage(1);
    setFrom_To_Towm_HasMore(true);
  }, [To_Town_search]);

  useEffect(() => {
    if (status === "Edit") {
      setformData((prev: any) => ({
        ...prev,
        BeltName: RowData?.BeltName,
        FromStateId: RowData?.FromStateId, // ✅ Add this missing field
        FromTownId: RowData?.FromTownId,
        ToStateId: RowData?.ToStateId,
        ToTownId: RowData?.ToTownId,
        CalculationType: RowData?.CalculationType,
        DistanceKm: RowData?.DistanceKm,
        Amount: RowData?.Amount,
        Remark: RowData?.Remark,
        TravelDocNeeded: RowData?.TravelDocNeeded,
      }));
    }
  }, [status]);

  const {
    data: TownList,
    isLoading: TownListIsLoading,
    isSuccess: TownListIsSuccess,
  } = useGetTownList({
    enabled: true,
    param: {
      page: 1,
      limit: 10,
      search: TownSeach || To_Town_search,
    },
  });

  useEffect(() => {
    const newItems = Array.isArray(TownList?.formatedData)
      ? TownList?.formatedData
      : [];
    setTownOption((prev: any) => {
      const updated = [...prev, ...newItems];

      const hasAll = updated.some((item) => item.id === "");
      const withoutAll = updated.filter((item) => item.id !== "");
      return hasAll
        ? [{ id: "", label: "All" }, ...withoutAll]
        : [{ id: "", label: "All" }, ...withoutAll];
    });
    if (TownList?.formatedData < 10) {
      setFrom_Towm_HasMore(false);
    }
  }, [TownList?.formatedData]);

  useEffect(() => {
    const newTtems = Array.isArray(TownList?.formatedData)
      ? TownList?.formatedData
      : [];

    setTo_Town_Option((prev: any) => {
      const updated = [...prev, ...newTtems];
      const hassAll = updated.some((item) => item.id === "");
      const withoutAll = updated.filter((item) => item.id !== "");
      return hassAll
        ? [{ id: "", label: "All" }, ...withoutAll]
        : [{ id: "", lable: "All" }, ...withoutAll];
    });

    if (TownList?.formatedData < 10) {
      setFrom_To_Towm_HasMore(false);
    }
  }, [TownList?.formatedData]);

  const [selectedTown, setSelectedTown] = useState<{
    id: number;
    label: string;
  } | null>(null);
  const [selectedTo_Town, setSelectedTo_Town] = useState<{
    id: number;
    label: string;
  } | null>(null);

  const handleClose = () => {
    setModalVisiable(!modalVisiable);
    setStatus("");
    setformData({
      GeoDistanceId: null,
      FromTownName: null,
      ToTownName: null,
      BeltName: undefined,
      FromStateId: null, // ✅ Add this missing field
      FromTownId: null,
      ToStateId: null,
      ToTownId: null,
      CalculationType: "",
      DistanceKm: null,
      Amount: null,
      Remark: "",
      TravelDocNeeded: "",
    });
    setSelectedTown(null);
    setSelectedTo_Town(null);
  };

  const toggleModal = () => {
    handleClose();
    setSelectedTown(null);
    setSelectedTo_Town(null);
  };

  const handleAdd = () => {
    setStatus("Add");
    setModalVisiable(!modalVisiable);
  };

  const expenseColumns = (handleEdit: (row: any) => void): any[] => [
    {
      name: "Belt Name",
      selector: (row: { BeltName: string }) => row.BeltName,
      minWidth: "150px",
      wrap: true,
      sortable: true,

      headCells: {
        style: {
          "&:first-of-type": {
            position: "sticky",
            left: 0,
            backgroundColor: "#fff",
            zIndex: 3,
          },
        },
      },
      style: {
        position: "sticky",
        left: 0,
        backgroundColor: "#fff",
        zIndex: 3,
        borderRight: "1px solid #ddd",
      },
    },

    {
      name: "From State",
      selector: (row: { FromStateName: string }) => row.FromStateName,
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "From Town",
      selector: (row: { FromTownName: string }) => row.FromTownName,
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "From Town City",
      selector: (row: { FromTownCity: string }) => row.FromTownCity,
      minWidth: "180px",
      sortable: true,
    },

    {
      name: "To State",
      selector: (row: { ToStateName: string }) => row.ToStateName,
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "To Town",
      selector: (row: { ToTownName: string }) => row.ToTownName,
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "To Town City",
      selector: (row: { ToTownCity: string }) => row.ToTownCity,
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Distance Km",
      selector: (row: { DistanceKm: string }) => row.DistanceKm,
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Calculation Type",
      selector: (row: { CalculationType: string }) => row.CalculationType,
      minWidth: "180px",
      sortable: true,
    },
    {
      name: "Amount",
      minWidth: "130px",
      selector: (row: { Amount: string }) => row.Amount,
      sortable: true,
    },
    {
      name: "Remark",
      selector: (row: { Remark: string }) => row.Remark,
      sortable: false,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: { Status: boolean }) =>
        row.Status ? "Active" : "Inactive",
      sortable: false,
    },
    {
      name: "Action",
      cell: (row: any) => (
        <button
          onClick={() => handleEdit(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            // height: "25px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
          }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];
  const [filterData, setFilterData] = useState({
    start: 1,
    length: 10,
    search: "",
    CalculationType: "",
    sortColumn: "GeoDistanceId",
    sortOrder: "desc",
    FromTownId: null,
    ToTownId: null,
  });

  const [formData, setformData] = useState<formInterface>({
    GeoDistanceId: null,
    FromTownName: null,
    ToTownName: null,
    BeltName: undefined,
    FromStateId: null, // ✅ Add this missing field
    FromTownId: null,
    ToStateId: null,
    ToTownId: null,
    CalculationType: "",
    DistanceKm: null,
    Amount: null,
    Remark: "",
    TravelDocNeeded: "",
  });
  // console.log('formDataCalculationType',formData.CalculationType);

  useEffect(() => {
    if (formData.DistanceKm === null) {
      // If user clears the input
      setformData((prev: any) => ({
        ...prev,
        Amount: 0,
      }));
      return;
    }

    // Convert to number just in case
    const distance = Number(formData.DistanceKm);
    if (!isNaN(distance)) {
      const calculated = Calculate_Amount_Geodistance(distance);
      setformData((prev: any) => ({
        ...prev,
        Amount: calculated,
      }));
    }
  }, [formData.DistanceKm]);

  // console.log('formData.Amount',formData.Amount);

  const {
    data: stateListData,
    isLoading: stateListDataIsLoading,
    isSuccess: stateListDataIsSucess,
  } = useGetStateList({ enable: true });
  const formatedData = Array.isArray(stateListData?.data)
    ? stateListData?.data.map((item: any) => ({
        id: item.id,
        label: item.name,
      }))
    : [];

  const { data, isLoading, isSuccess } = useGetGeoDistanceList({
    enable: true,
    params: {
      start: filterData.start,
      length: filterData.length,
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      sortColumn: filterData.sortColumn,
      sortOrder: filterData.sortOrder,
      ...(filterData.CalculationType === "" ||
      filterData.CalculationType === "All"
        ? {}
        : { CalculationType: filterData.CalculationType }),
      ...(filterData.FromTownId === ""
        ? {}
        : { FromTownId: filterData.FromTownId }),
      ...(filterData.ToTownId === "" ? {} : { ToTownId: filterData.ToTownId }),
    },
  });

  const {
    data: ConfigData,
    isLoading: ConfigDataIsLoading,
    isSuccess: ConfigDataIsSuccess,
  } = useGetConfigStatus({ enable: true });
  const { mutate: addGeoDistance } = useAddGeoDistace();
  const { mutate: updateGeoDistance } = useUpdateGeoDistannce();
  const handleInput = (key: any, value: any) => {
    setformData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleEdit = (row: any) => {
    // console.log("row:::", row);
    setRowData(row);
    setStatus("Edit");
    try {
      setModalVisiable(!modalVisiable);
    } catch (er) {
      alert(`ERror in-->${er}`);
    }
  };

  const handleDropDownFilter = (key: any, value: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSearch = (text: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      search: text,
    }));
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleChangeRowPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const ReqBody: RebBodyInterface = {
      BeltName: formData.BeltName || undefined,
      FromStateId: formData.FromStateId,
      FromTownId: formData.FromTownId,
      ToStateId: formData.ToStateId,
      ToTownId: formData.ToTownId,
      CalculationType: formData.CalculationType,
      DistanceKm: formData.DistanceKm,
      Amount: formData.Amount,
      Remark: formData.Remark || "",
      TravelDocNeeded: formData.TravelDocNeeded === "YES" ? "Y" : "N",
    };

    if (status === "Add") {
      if (formData.FromTownId === formData.ToTownId) {
        showToast.warning("Form Town and To Town Should not be same ");
      } else {
        addGeoDistance(ReqBody, {
          onSuccess: (data) => {
            console.log("Success Message");
            handleClose();
          },
          onError: (error: any) => {
            console.log("Error adding geo distance", error);
          },
        });
      }
    }

    if (status === "Edit") {
      if (formData.FromTownId === formData.ToTownId) {
        showToast.warning("Form Town and To Town Should not be same ");
      } else {
        updateGeoDistance(
          {
            ReqBody: ReqBody,
            id: Number(RowData?.GeoDistanceId),
          },
          {
            onSuccess: (data) => {
              handleClose();
            },
            onError: (error: any) => {
              console.log("Error adding geo distance", error);
            },
          }
        );
      }
    }
  };

  const CalculationType = [
    ...[{ id: "", label: "All" }],
    ...(Array.isArray(ConfigData?.CalculationType)
      ? ConfigData?.CalculationType.map((item: any) => ({
          id: item.id,
          label: item.label,
        }))
      : []),
  ];

  function Calculate_Amount_Geodistance(distance: any) {
    let cost = 0;
    if (distance <= 100) {
      cost = distance * 3;
    } else if (distance <= 150) {
      cost = 100 * 3 + (distance - 100) * 1.5;
    } else {
      cost = 100 * 3 + 50 * 1.5 + (distance - 150) * 1.25;
    }
    return cost;
  }

  const downloadExcelGet = async () => {
    const param: Record<string, any> = {
      ...(filterData.search == "" ? {} : { search: filterData.search }),
      ...(filterData.CalculationType == ""
        ? {}
        : { CalculationType: filterData.CalculationType }),
      ...(filterData.FromTownId == null
        ? {}
        : { FromTownId: filterData.FromTownId }),
      ...(filterData.ToTownId == null ? {} : { ToTownId: filterData.ToTownId }),
    };

    const queryString = new URLSearchParams(param).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.GEO_DISTANCE.GET_EXCEL_DOWNLOAD}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } =
        response?.data?.data || null;

      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus('Loading..');
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) =>{ 
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          }
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Geo Distance"
        buttons={[
          {
            label: "+ Add Geo Distance",
            onClick: () => handleAdd(),
            color: COLORS.primary,
          },
          {
            label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
          // {
          //   label: "CSV",
          //   onClick: () => console.log("Download CSV"),
          //   color: "#43B9B2",
          // },
        ]}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "auto",
          marginTop: "2%",
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <BasicDataTable
            customStyle={{
              headCells: {
                style: {
                  fonstSize: 14,
                  fontWeight: "bold",
                  zIndex: 2,
                  "&:first-of-type": {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                    background: "#fff",
                  },
                },
              },
              head: {
                style: {
                  backgroundColor: "red",
                  zIndex: 4,
                },
              },
            }}
            SearchPlaceholder="Search By BeltName"
            dynamicHeightOnRowsPerPage={true}
            showSpinner={isLoading}
            search={true}
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(limit: any, pageNo: any) => {
              handleChangeRowPerPage(limit, pageNo);
            }}
            paginationTotalRows={data?.rowData?.data?.recordsTotal || 0}
            Title="Geo Distance"
            columns={expenseColumns(handleEdit)}
            data={(!isLoading && isSuccess && data?.formatedData) || []}
            handleSearch={(text: any) => handleSearch(text)}
            headerContent={
              <>
                <RoundedDropdown
                  options={CalculationType || []}
                  onSelect={(value: any) =>
                    handleDropDownFilter("CalculationType", value.label)
                  }
                  defaultLabel="All"
                  width="150px"
                  isShowHeading
                  DropdownHeading="Calculation Type"
                  headingColor="#2e8dd3"
                />

                <div style={{ marginLeft: 10 }}>
                  <CustomDropdown
                    placeholder="All"
                    DropdownLabel="From Town"
                    value={filterData.FromTownId}
                    onChange={(id) => {
                      setFilterData((prev: any) => ({
                        ...prev,
                        FromTownId: id,
                        start: 1,
                      }));
                    }}
                    fetchData={async ({ page, limit, search }) => {
                      const param = {
                        start: page,
                        length: limit,
                        search: search,
                      };
                      const res = await getTownList2(param);
                      let formatedData = Array.isArray(res.rowData.data?.data)
                        ? res.rowData?.data?.data.map((item: any) => ({
                            id: item.id,
                            label: item.label,
                          }))
                        : [];
                      const rowData = (await res).rowData?.data?.data;
                      if (page === 1) {
                        formatedData = [
                          { id: "", label: "All" },
                          ...formatedData,
                        ];
                      }
                      const hasMore = Object.keys(rowData).length == limit;
                      return {
                        data: formatedData,
                        hasMore,
                      };
                    }}
                    includeAllOption
                  />
                </div>
                <div style={{ marginLeft: 10 }}>
                  <CustomDropdown
                    placeholder="All"
                    DropdownLabel="To Town"
                    value={filterData.ToTownId}
                    onChange={(id) => {
                      setFilterData((prev: any) => ({
                        ...prev,
                        ToTownId: id,
                        start: 1,
                      }));
                    }}
                    fetchData={async ({ page, limit, search }) => {
                      const param = {
                        start: page,
                        length: limit,
                        search: search,
                      };
                      const res = await getTownList2(param);
                      let formatedData = Array.isArray(res.rowData.data?.data)
                        ? res.rowData?.data?.data.map((item: any) => ({
                            id: item.id,
                            label: item.label,
                          }))
                        : [];
                      const rowData = (await res).rowData?.data?.data;
                      if (page === 1) {
                        formatedData = [
                          { id: "", label: "All" },
                          ...formatedData,
                        ];
                      }
                      const hasMore = Object.keys(rowData).length == limit;
                      return {
                        data: formatedData,
                        hasMore,
                      };
                    }}
                    includeAllOption
                  />
                </div>
              </>
            }
          />
        </div>
      </div>

      {modalVisiable && (
        <RouteModal
          isOpen={modalVisiable}
          toggle={toggleModal}
          title={status === "Edit" ? "Edit Geo Distance" : "Add Geo Distance"}
          size="lg"
          content={
            <form onSubmit={handleSubmit}>
              <div>
                {/* Form Details */}
                <div className="row mb-0">
                  <div className="col-sm-6">
                    <CustomInput
                      asterisk={true}
                      value={formData.BeltName}
                      require
                      style={{ borderRadius: "4px" }}
                      label="Belt Name"
                      placeholder="Belt Name"
                      type="text"
                      onChange={(e: any) =>
                        handleInput("BeltName", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-sm-6">
                    <ReusableDropdown
                      asterisk={true}
                      options={(!stateListDataIsLoading && formatedData) || []}
                      value={formData.FromStateId}
                      onChange={(value: any) => {
                        //  console.log('vale From State',value);
                        handleInput("FromStateId", value);
                      }}
                      DropdownHeading="From State"
                    />
                  </div>
                  <div className="col-sm-6">
                    <PaginatedRouteDropdown
                      asterisk={true}
                      DropdownHeading="From Town"
                      // value={formData.FromTownId}
                      initialSelectedOptions={selectedTown}
                      //  initialSelectedOptions={formData.FromTownId}
                      onChange={(val: any) => {
                        setformData((prev: any) => ({
                          ...prev,
                          FromTownId: val.id,
                        }));
                      }}
                      fetchOptions={async (start: any, search: any) => {
                        const res = await getTownList({
                          search: search || "",
                          start,
                          length: 10,
                        });
                        return res.rowData?.data?.data.map((item: any) => ({
                          id: Number(item.id),
                          label: String(item.label),
                        }));
                      }}
                    />
                  </div>{" "}
                  <div className="col-sm-6">
                    <PaginatedRouteDropdown
                      asterisk={true}
                      DropdownHeading="To Town"
                      initialSelectedOptions={selectedTo_Town}
                      onChange={(val: any) => {
                        // console.log("selected To Town value::",val.id);
                        setformData((prev: any) => ({
                          ...prev,
                          ToTownId: val.id,
                        }));
                      }}
                      fetchOptions={async (page: any, search: any) => {
                        const res = await getTownList({
                          search: search || "",
                          page,
                          limit: 10,
                        });
                        return res.rowData?.data?.data.map((item: any) => ({
                          id: Number(item.id),
                          label: String(item.label),
                        }));
                      }}
                    />
                  </div>
                  <div className="col-sm-6">
                    <ReusableDropdown
                      options={(!stateListDataIsLoading && formatedData) || []}
                      value={formData.ToStateId}
                      onChange={(value: any) => {
                        handleInput("ToStateId", value);
                      }}
                      DropdownHeading="To State"
                      asterisk={true}
                    />
                  </div>{" "}
                  <div className="col-sm-6">
                    <ReusableDropdown
                      options={ConfigData?.CalculationType || []}
                      value={formData.CalculationType}
                      onChange={(value: any) => {
                        handleInput("CalculationType", value);
                      }}
                      DropdownHeading="Type"
                    />
                  </div>
                  <div className="col-sm-6">
                    <CustomInput
                      value={String(formData.DistanceKm)}
                      type="number"
                      style={{ borderRadius: "4px" }}
                      label="Distance In Km"
                      asterisk
                      required
                      onChange={(e: any) =>
                        handleInput("DistanceKm", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>{" "}
                  <div className="col-sm-6">
                    <CustomInput
                      // value={String(formData.Amount)}
                      value={formData.Amount ?? 0}
                      style={{ borderRadius: "4px" }}
                      type="number"
                      label="Amount"
                      asterisk
                      required
                      disabled={
                        formData.CalculationType == "K" ||
                        formData.CalculationType == ""
                          ? true
                          : false
                      }
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        handleInput("Amount", e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-sm-6">
                    <CustomInput
                      value={formData.Remark}
                      style={{ borderRadius: "4px" }}
                      type="text"
                      label="Remark"
                      asterisk
                      required
                      onChange={(e: any) =>
                        handleInput("Remark", e.target.value)
                      }
                    />
                  </div>{" "}
                  <div className="col-sm-6">
                    <ReusableDropdown
                      options={ConfigData?.TravelDocNeeded || []}
                      value={formData.TravelDocNeeded}
                      onChange={(value: any) => {
                        // console.log("value", value);
                        handleInput("TravelDocNeeded", value);
                      }}
                      DropdownHeading="Metro Class(B)"
                    />
                  </div>
                </div>
                <br />
                {/* Buttons */}
                <div className="d-flex justify-content-start gap-2">
                  <Btn
                    style={{ backgroundColor: "#43B9B2", color: "white" }}
                    type="submit"
                  >
                    Submit
                  </Btn>
                  <Btn
                    style={{
                      backgroundColor: "#F9FAFC",
                      color: "#000",
                      border: "1px solid #E0E0E0",
                    }}
                    type="button"
                    onClick={handleClose}
                  >
                    Cancel
                  </Btn>
                </div>
              </div>
            </form>
          }
        />
      )}
    </div>
  );
};

export default ExpGeoDistance;
